import React, { FunctionComponent } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { financialItemStyles } from "./styles/financialItemStyle";
import { Grid, Typography } from "@material-ui/core";
import "../Print.css";

type CashierDataProps = {
  cashierData: Array<object>;
  cashierTotal: string;
  source: string;
};
export const CashierSalesSummary: FunctionComponent<CashierDataProps> = ({
  cashierData,
  cashierTotal,
  source,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>
                Cashier Collection Summary
              </Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableHead className={classes.tableRow}>
              <TableRow>
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "5%" }}
                >
                  SL
                </TableCell>
                <TableCell
                  align="left"
                  className={classes.headCell}
                  component="th"
                  scope="row"
                  // style={{ width: "40%" }}
                ></TableCell>

                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Bills
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cashierData &&
                cashierData.map((data: any, i: number) => (
                  <TableRow>
                    <TableCell align="left" className={classes.headColor}>
                      {i + 1}
                    </TableCell>
                    <TableCell align="left" className={classes.headColor}>
                      {data.full_name}
                    </TableCell>
                    <TableCell align="right" className={classes.headColor}>
                      {data.total_bill_count ? data.total_bill_count : "0"}
                    </TableCell>
                    <TableCell align="right" className={classes.headColor}>
                      {data.total_system_amount_sum
                        ? data.total_system_amount_sum
                        : "0.00"}
                    </TableCell>
                  </TableRow>
                ))}

              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headColor}
                ></TableCell>
                <TableCell align="left" className={classes.headCell}>
                  Total
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                ></TableCell>
                <TableCell align="right" className={classes.headCell}>
                  {cashierTotal ? cashierTotal : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
